<template>
  <div id="recruitment-information">
    <vice-title>
      <h3>{{ this.$t("lang.Recruit.joinUs") }}</h3>
    </vice-title>
    <img src="../../assets/images/recruitment-img.png" alt="" />
    <h3 class="information-title">{{ this.$t("lang.Recruit.welcomeYou") }}</h3>
    <p class="information-content">
      {{ this.$t("lang.Recruit.welcomeYouDetail1") }}
    </p>
    <p class="information-email" v-html="this.$t('lang.Recruit.welcomeYouDetail2')">

    </p>
  </div>
</template>

<script>
import ViceTitle from "../ViceTitle";
export default {
  name: "RecruitmentInformation",
  components: {
    ViceTitle
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/global";
#recruitment-information {
  width: $width;
  margin: 0 auto;
  background: #ffffff;
  overflow: hidden;
  .information-title {
    color: $contentColor;
    line-height: 30px;
    margin-top: 50px;
    /*margin: 0 30px 30px 30px;*/
  }
  .information-email {
    color: #c5c5c5;
    line-height: 30px;
    text-indent: 2em;
    /*margin: 0 30px 30px 30px;*/
    .email {
      color: $titleBlueClue;
      cursor: pointer;
    }
  }
  .information-content {
    color: #c5c5c5;
    line-height: 30px;
    text-indent: 2em;
    /*margin: 0 30px 30px 30px;*/
  }
}
</style>
